<template id="bar-chart">
    <div id="container" class="svg-container" align="center">
        <h1>{{ title }}</h1>
        <!--<svg v-if="redrawToggle === true" :width="svgWidth" :height="svgHeight" ref="chart">-->
        <svg :width="200" :height="180" ref="chart" v-if="data !== null">
            <rect
                    v-for="item in data"
                    class="bar-positive"
                    :key="item[xKey]"
                    :x="xScale(item[xKey])"
                    :y="yScale(0)"
                    :width="xScale.bandwidth()"
            ></rect>
            <g ref="axisX" :transform="`translate(0,${svgHeight})`"></g>
            <g ref="axisY"></g>
        </svg>
    </div>
</template>
<script>
import * as d3 from 'd3'

export default {
    name: 'BarChart',
    props: {
      title: String,
      xKey: String,
      yKey: String,
      data: Array,
      menu: String
    },
    mounted () {
      this.svgWidth = document.getElementById('container').offsetWidth * 1
      this.AddResizeListener()
      this.AnimateLoad()
      this.addAxisX()
      this.addAxisY()
      this.addTT1()
    },
    data: () => ({
      svgWidth: 3,
      redrawToggle: true,
      todoHovered: '',
      todoHovered2: ''
    }),
    watch: {
      data: function (newVal, oldVal) {
        console.warn('data changed', newVal, oldVal)
        setTimeout(() => {
          this.AnimateLoad()
        }, 300)
      }
    },
    methods: {
      inrFormatter: function(num) {
          if (Math.abs(num) >= 1000000000) {
              return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'HCr';
          }
          if (Math.abs(num) >= 10000000) {
              return (num / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cr';
          }
          if (Math.abs(num) >= 100000) {
              return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
          }
          if (Math.abs(num) >= 1000) {
              return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
          }
          if (Math.abs(num) < 1000 && Math.abs(num)%1000 ==0) {
              return num.toFixed(2);
          }
          return num;
      },

      AnimateLoad: function () {
       // console.log('the rfm data received from html is:', this.data)
        if (this.data)
          d3.select(this.$refs.chart)
            .selectAll('rect')
            .data(this.data)
            .transition()
            .delay((d, i) => {
              return i * 10 //previously it was 150 Abhiram => altered and kept for 100 because it reduces loading time of the plot
            })
            .duration(100) //previously it was 1000 Abhiram => altered and kept for 100 because it reduces loading time of the plot
            .attr('y', d => {
              return this.yScale(d[this.yKey])
            })
            //To Reduce the width of the bar which was occupying complete width,if no data found
            .attr('width', 26)
            // attach a line
            //For Progressive Color of Bars
            .style('fill', function (d) {
              if (d.monetaryScore <= 1) {
                return '#E2FFFF'
              } else if (d.monetaryScore <= 2) {
                return '#BAFFFF'
              } else if (d.monetaryScore <= 3) {
                return '#9CFFFF'
              } else if (d.monetaryScore <= 4) {
                return '#77F9F9'
              } else if (d.monetaryScore <= 5) {
                return '#0AFBFB'
              } else {
                return '#15f4ee'
              }
            })

            .attr('x', (d, z) => {
              return (z + 1) * 32.5 + z // Alter (z+1) value to move visulization left to right // changed from 27.5 to 32.5 on 2020/11/01
            })
            .attr('height', d => {
               return this.svgHeight - this.yScale(d[this.yKey])
            })
        else
          console.info('not drawing chart as data is not OK', this.data)
      },
      AddResizeListener: function () {
        // redraw the chart 300ms after the window has been resized
        window.addEventListener('resize', () => {
          this.$data.redrawToggle = false
          setTimeout(() => {
            this.$data.redrawToggle = true
            this.AnimateLoad()
          }, 300)
        })
      },
      addAxisX () {
        d3.select(this.$refs.axisX)
          .call(d3.axisBottom(this.xScale))
          .attr('transform', 'translate(0, 115)')
          .selectAll('rect')
          .append('line')
          .attr('class', 'mouseover-line')
          .style('stroke', '#000')

      },
      addAxisY () {
        var numberFormat = this.inrFormatter;
        d3.select(this.$refs.axisY)
          .call(d3.axisLeft(this.yScale).ticks(4) .tickFormat(numberFormat))
          .attr('transform', 'translate(32, 0)')
          .selectAll('rect')
      },
      addTT1 () {
        var tooltip = d3.select('body')
          .append('div')
          .style('position', 'absolute')
        d3.select(this.$refs.chart)
          .selectAll('rect')
          //MouseOver Event Calling
          .on('mouseover', d => {
            tooltip
              .style('left', d3.event.pageX - 50 + 'px')
              .style('top', d3.event.pageY - 100 + 'px')
              .style('display', 'block')
              .style('background-color', 'rgba(0, 0, 0, 0.8)')
              .style('color', 'white')
              .attr('opacity', 0.5)
              .style('font', '12px times')
              .style('font-weight', 'bold')
              .style('border-radius', '2px')
              .style('pointer-events', 'none')
              .html('R' + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.recencyScore) + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.recencyRange) + '<br>' +
                'F' + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.frequencyScore) + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.frequencyRange) + '<br>'
                + 'M' + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.monetaryScore) + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.monetaryRange) + '<br>'
                + 'C' + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + ('#') + '<tspan class="mr-1">:</tspan>' + '<tspan class="ml-1"></tspan>' + (d.customerCount))
          })
          //Mouseout/Mouse Leave Event Calling
          .on('mouseleave', () => {
            tooltip.style('display', 'none')
          })
      },
    }, //Method Ends
    computed: {
      dataMax: function () {
        return d3.max(this.data, d => {
          return d[this.yKey]
        })
      },
      dataMin: function () {
        return d3.min(this.data, d => {
          return d[this.yKey]
        })
      },
      xScale: function () {
        return d3.scaleBand()
          .rangeRound([22, this.svgWidth])
          .padding(0.9)
          .domain(
            this.data.map(d => {
              return d[this.xKey]
            })
          )
      },
      yScale: function () {
        return d3.scaleLinear()
          .rangeRound([this.svgHeight, 10])
          .domain([0, d3.max(this.data, d => { return d[this.yKey] })])

      },
      svgHeight: function () {
        return this.svgWidth / 1.61803398875 // golden ratio
        // return this.svgWidth / 2.61803398875; // golden ratio edited
      },
    }
  }
</script>

<style scoped>
    .bar-positive {
        fill: steelblue;
        transition: r 0.2s ease-in-out;
    }
    .bar-positive:hover {
        fill: palevioletred;
    }
    .svg-container {
        display: flex;
        position: relative;
        width: 100%;
        padding-bottom: 1%;
        vertical-align: top;
        overflow: hidden;
    }
    .axis text {
        font: 10px sans-serif;
    }
    .axis line,
    .axis path {
        fill: none;
        stroke: #000;
        shape-rendering: crispEdges;
    }
</style>